import AssignmentsForPatientsFieldsColumn from "./AssignmentsForPatientsFieldsColumn";

export default AssignmentsForPatientsFieldsColumn;
